import isTablet from "PublicHelpers/isTablet";

const mixin = {
  data() {
    return {
      tablet: isTablet(),
    };
  },
  methods: {
    checkTablet() {
      this.tablet = isTablet();
    },
  },
  created() {
    window.addEventListener("resize", this.checkTablet);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkTablet);
  },
};

export default mixin;
